import { render, staticRenderFns } from "./relationshipMaintenance.vue?vue&type=template&id=8e57a2ce&scoped=true"
import script from "./relationshipMaintenance.vue?vue&type=script&lang=js"
export * from "./relationshipMaintenance.vue?vue&type=script&lang=js"
import style0 from "./relationshipMaintenance.vue?vue&type=style&index=0&id=8e57a2ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e57a2ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e57a2ce')) {
      api.createRecord('8e57a2ce', component.options)
    } else {
      api.reload('8e57a2ce', component.options)
    }
    module.hot.accept("./relationshipMaintenance.vue?vue&type=template&id=8e57a2ce&scoped=true", function () {
      api.rerender('8e57a2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessPlatform/relationshipMaintenance.vue"
export default component.exports